/**
 * 「キーを 1 つ入れるだけの小さな画面」（pages/EnterKeyPage.tsx・2026-10-04 creator/chat-secrets）の英語。
 * en.ts が `...enEnterKey` で取り込む（ja.enterKey.ts が同じキーを全部持つことを型で強制）。
 *
 * 言葉の決め事（founder 2026-10-04「API・シークレットキーという言葉を知らない前提」・enterKey.test.ts が見張る）:
 *   - API / secret / environment / production / deploy / token / request などの中の言葉を使わない。見える物で言う（"your key"・"the box"）。
 *     名前（{name} = OPENAI_API_KEY など）は差し込みの値 = 言葉ではない（小さく添えるだけ）
 *   - どちらで使うか: production = "your published app ({url})" / development = "your test app ({url})"（MCP の secretInput.ts placeWords と同じ）。
 *     founder 2026-10-04「抽象的にすることでどうとでも意味を持つようなことばにしないでください」= 「the one everyone uses」などは使わない。
 *     {url} = 本体の hosting の本物の URL。読めなければ …NoUrl の文
 *   - 保存したら「チャットに戻って」（founder の言い方そのまま。閉じた機能 chat とは別 = wordsPass.test.ts の ALLOWED に理由つき）
 */
export const enEnterKey = {
  // 見出しは「何のキーか」を言う（2026-10-04 creator/chat-secrets-2・管理「名前を読まないと何のキーかわからない」）。
  // {service} = AI が渡すサービス名（enterKey.ts keyLabelOk を通った物）。無ければ {name}（OPENAI_API_KEY など）で言う。
  // enterKey.title はリンクがおかしいとき（何のキーか分からない）だけ
  'enterKey.title': 'Paste your key',
  'enterKey.titleFor': 'Paste your {service} key',
  'enterKey.titleNamed': 'Paste {name}',
  'enterKey.lead': 'Paste it into the box below, then press Save.',
  'enterKey.where.production': 'It will be used in your published app ({url}).',
  'enterKey.where.development': 'It will be used in your test app ({url}).',
  'enterKey.where.productionNoUrl': 'It will be used in your published app.',
  'enterKey.where.developmentNoUrl': 'It will be used in your test app.',
  'enterKey.label': 'Key',
  'enterKey.placeholder': 'Paste here',
  'enterKey.safe': 'Your AI cannot see what you paste here, and it does not go into your conversation.',
  'enterKey.nameNote': 'Saved as {name} (your AI chose this name).',
  'enterKey.save': 'Save',
  'enterKey.empty': 'Paste your key first.',
  'enterKey.tooLong': 'This is too long (up to 5 KB). Check that you copied only the key.',
  'enterKey.confirmTitle': 'Save it to your published app?',
  'enterKey.confirmBody': 'People using your published app now will start using this key right away.',
  'enterKey.confirmButton': 'Save',
  'enterKey.doneTitle': 'Saved',
  'enterKey.doneBody': 'Go back to the chat with your AI. You can close this page.',
  'enterKey.again': 'Enter it again',
  'enterKey.badLink': 'This link is not right. Ask your AI to open the page again.',
  'enterKey.error.notReady': 'This cannot be used yet. Ask your AI to "put the server online", then open this page again.',
  'enterKey.error.stopped': 'This is turned off right now. Ask your AI to turn it on, then open this page again.',
  'enterKey.error.rateLimited': 'Saved too many times in a short time. Wait about {seconds} seconds and try again.'
};
